var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.18 37.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef5725;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.66,18.36l-1.66,.99c.05,2.25,.49,4.4,1.25,6.39l.4-.16v-7.22h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.59,31.31c.4,.47,.83,.92,1.27,1.34l4.69-1.34H4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.59,26.57s.04,.1,.06,.14v-.17l-.06,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.31,23.66c.39-1.51,.59-3.09,.59-4.71,0-2.34-.43-4.58-1.2-6.65l-15.95,6.49v1.5h-3.69l-12.12,4.93v3.07h15.81v.11s16.56-4.74,16.56-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.66,11.18C.67,13.37,.09,15.78,.01,18.31l1.65-.99v-6.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.06,6.31L27.33,1.95c-2.53-1.25-5.38-1.95-8.39-1.95C13.33,0,8.29,2.44,4.82,6.31h15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.75,29.32v1.99h-6.96l-7.15,2.04c3.31,2.83,7.61,4.54,12.31,4.54,8.47,0,15.65-5.56,18.07-13.23l-16.27,4.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.93 15.36 15.01 9.33 4.93 9.33 4.93 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.93 24.25 14.7 20.28 4.93 20.28 4.93 24.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.93,17.26h15.81v.56l15.62-6.35c-1.64-3.82-4.51-7-8.11-9.03l-7.51,4.5v2.4h-4l-11.81,7.07v.86h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.46,26.46V11.43h10.42v2.6h-7.63v3.54h7.63v2.58h-7.63v3.7h7.63v2.6h-10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.39,26.46V11.43h10.42v2.6h-7.63v3.54h7.63v2.58h-7.63v3.7h7.63v2.6h-10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.27,26.46V11.43h5.79c2.22,0,3.96,.67,5.25,2.03,1.28,1.34,1.91,3.17,1.91,5.51s-.65,4.13-1.95,5.47c-1.28,1.34-3.07,2.01-5.33,2.01h-5.67Zm2.77-2.65h3.01c1.36,0,2.4-.47,3.15-1.38s1.14-2.09,1.14-3.5-.37-2.52-1.12-3.44c-.75-.92-1.79-1.38-3.15-1.38h-3.03v9.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.17,24.51c-1.46-1.46-2.2-3.31-2.2-5.55s.77-4.13,2.3-5.59c1.52-1.46,3.42-2.2,5.63-2.2,2.44,0,4.74,1.04,6.1,2.52l-1.85,1.95c-1.16-1.2-2.58-1.79-4.25-1.79-1.44,0-2.66,.49-3.64,1.44-.96,.96-1.44,2.18-1.44,3.64s.47,2.64,1.42,3.62,2.18,1.46,3.62,1.46c1.61,0,3.21-.69,4.21-1.73v-2.28h-4.35v-2.44h6.91v6.08c-1.91,2.01-4.19,3.03-6.85,3.03-2.26,0-4.13-.73-5.61-2.18v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.37,26.46l-5.02-15.03h3.03l3.17,10.31,3.54-10.31h1.69l3.62,10.31,3.11-10.31h3.03l-5,15.03h-2.2l-3.39-10.17-3.36,10.17h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.94,23.83l1.67-1.91c.96,1.44,2.26,2.18,3.9,2.18,1.36,0,2.3-.75,2.3-1.75,0-.67-.47-1.24-1.4-1.71-.2-.1-.69-.31-1.48-.61-.79-.33-1.38-.61-1.77-.83-1.57-.92-2.36-2.16-2.36-3.7,0-1.24,.47-2.26,1.38-3.07,.92-.83,2.11-1.24,3.6-1.24,1.95,0,3.56,.69,4.82,2.07l-1.55,1.99c-.83-.96-2.16-1.46-3.23-1.46-1.22,0-2.03,.63-2.03,1.59,0,.63,.41,1.16,1.24,1.59l1.59,.73c.83,.35,1.42,.63,1.79,.81,1.65,.83,2.48,2.07,2.48,3.68,0,1.32-.51,2.42-1.5,3.25-1,.83-2.3,1.26-3.88,1.26-2.28,0-4.35-1.02-5.55-2.87h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.04,14.12h-4.33v-2.68h11.47v2.68h-4.33v12.34h-2.81V14.12Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdg);
export default __webpack_public_path__ + "static/media/edg.3e6fecdfc311cbb81229217d19d7344d.svg";
export { ForwardRef as ReactComponent };